export default __webpack_public_path__ + "98f9e47ccdf32ccd3e0d73112e730bb4.png";